import { render } from "./ViewSupport.vue?vue&type=template&id=1fc06862&scoped=true&ts=true"
import script from "./ViewSupport.vue?vue&type=script&lang=ts"
export * from "./ViewSupport.vue?vue&type=script&lang=ts"

import "./ViewSupport.vue?vue&type=style&index=0&id=1fc06862&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc06862"]])

export default __exports__